<template>
  <a v-if="isSelfTarget" :href="to"><slot /></a>
  <a v-else-if="isExternalLink" :href="to" target="_blank"><slot /></a>
  <a v-else-if="!isDynamicPage" :href="to" target="_blank"><slot /></a>
  <router-link v-else-if="isStaticPage" :to="to"><slot /></router-link>
  <router-link
    v-else-if="isDynamicPage"
    :to="routingDataPath(routingData, to)"
    @click="initPage({ id: routingData?.[0] ?? null, type: pathType, website_id: websiteId })"
  >
    <slot />
  </router-link>
  <div v-else><slot /></div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { computed } from 'vue'
import { useSectionsStore } from '@/stores/section'

const sectionsStore = useSectionsStore()
const { initPage } = sectionsStore

const props = defineProps({
  to: {
    type: [Object, String],
    default: ''
  },
  inactiveClass: String,
  routingData: Array,
  pathType: String,
  websiteId: [Number, String, null]
})

const routingDataPath = (routingData, url) => {
  if (url) {
    return url.replace(/.*\/\/[^\/]*/, '')
  }
  if (routingData) {
    return `/${routingData.join('/')}`
  }
  return '/'
}

const isExternalLink = computed(
  () => props?.pathType === 'EXTERNAL_URL' && props.to?.startsWith('http')
)
const isStaticPage = computed(() => props?.pathType === 'EXTERNAL_URL' && props.to?.startsWith('/'))
const isDynamicPage = computed(() => !!props?.routingData)
const isSelfTarget = computed(() => props?.pathType === 'NEWS' && props.to?.includes('wybory-samorzadowe-2024'))
</script>
